import {atom} from 'recoil';

export const persistentAtom = ({ key, defaultValue }: any) => {
    const savedValue = localStorage.getItem(key);
    const initialValue = savedValue ? JSON.parse(savedValue) : defaultValue;
    return atom({
        key,
        default: initialValue,
        effects_UNSTABLE: [
            ({setSelf, onSet}) => {
                setSelf(initialValue);
                onSet(newValue => {
                    localStorage.setItem(key, JSON.stringify(newValue));
                });
            },
        ],
    });
};
